import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { GadgetFilterDTO } from '@signature-it/ngx-generic/models';
declare let _: any;
declare let $: any;

@Injectable({
    providedIn: 'root'
})
export class GadgetsService {

    public gadgetFilter = new BehaviorSubject(GadgetFilterDTO.createFromArray(GenericConfig.filterGadget));
    public lastUpdated: Subject<string> = new Subject()

    constructor() {
    }

    public compareVal(arr, serverSideFilter) {
        if (!arr || !serverSideFilter) {
            return false;
        }
        let data =  _.some(serverSideFilter, (a1, idx) => a1.key !== arr[idx].key
            || a1.value !== arr[idx].value
        );
        return data;
        // let data = arr.filter(({ value: val1 }) => !serverSideFilter.some(({ value: val2 }) => val2 != val1));
        // return data.length;
    }

    public hasParams(serverSideFilter) {
        return serverSideFilter.every( d  => !!d.value);
    }

    public setParams(serverSideFilter, dataConfig) {
        let data = {};
        serverSideFilter.forEach(dataFilter => {
            data[dataFilter.key] = dataFilter.value;
        });
        Object.keys(dataConfig).forEach(key => {
            data[key] = dataConfig[key];
        });

        return data;
    }
}
